// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.background-image {
  position: absolute;
  width: 100%;
  height: 100%;
}

.trash-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.trash-image {
  position: absolute;
  width: 150px;
  height: 150px;
  cursor: pointer;
}

.trash-image.hidden {
  display: none;
}

.timer {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 24px;
  font-weight: bold;
  z-index: 1; /* 确保文字在背景图片之上 */
}

.score {
  position: absolute;
  top: 40px; /* 确保分數在剩餘時間下方 */
  left: 10px;
  font-size: 24px;
  font-weight: bold;
  z-index: 1; /* 确保文字在背景图片之上 */
}

.stars {
  position: absolute;
  top: 70px; /* 确保星等在分數下方 */
  left: 10px;
  font-size: 24px;
  font-weight: bold;
  z-index: 1; /* 确保文字在背景图片之上 */
}

.stars.visible {
  display: block;
}

.start-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px 40px;
  font-size: 24px;
  font-weight: bold;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 2; /* 确保按钮在最上层 */
}

.game-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.game-image {
  cursor: pointer;
  max-width: 100%;
  max-height: 100%;
}

.start-button1 {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px 40px;
  font-size: 94px;
  font-weight: bold;
  color: red;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 2; /* 确保按钮在最上层 */
  font-family: 'WP010-05', sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/Game1.css"],"names":[],"mappings":";;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,UAAU,EAAE,gBAAgB;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,gBAAgB;EAC3B,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,UAAU,EAAE,gBAAgB;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,cAAc;EACzB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,UAAU,EAAE,gBAAgB;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU,EAAE,aAAa;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU,EAAE,aAAa;EACzB,mCAAmC;AACrC","sourcesContent":["\n\n.container {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.background-image {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.trash-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.trash-image {\n  position: absolute;\n  width: 150px;\n  height: 150px;\n  cursor: pointer;\n}\n\n.trash-image.hidden {\n  display: none;\n}\n\n.timer {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  font-size: 24px;\n  font-weight: bold;\n  z-index: 1; /* 确保文字在背景图片之上 */\n}\n\n.score {\n  position: absolute;\n  top: 40px; /* 确保分數在剩餘時間下方 */\n  left: 10px;\n  font-size: 24px;\n  font-weight: bold;\n  z-index: 1; /* 确保文字在背景图片之上 */\n}\n\n.stars {\n  position: absolute;\n  top: 70px; /* 确保星等在分數下方 */\n  left: 10px;\n  font-size: 24px;\n  font-weight: bold;\n  z-index: 1; /* 确保文字在背景图片之上 */\n}\n\n.stars.visible {\n  display: block;\n}\n\n.start-button {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 20px 40px;\n  font-size: 24px;\n  font-weight: bold;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  z-index: 2; /* 确保按钮在最上层 */\n}\n\n.game-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.game-image {\n  cursor: pointer;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.start-button1 {\n  position: absolute;\n  top: 40%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 20px 40px;\n  font-size: 94px;\n  font-weight: bold;\n  color: red;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  z-index: 2; /* 确保按钮在最上层 */\n  font-family: 'WP010-05', sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
